export const sitemapTranslation = {
  en: {
    Title: "Title",
    URL: "URL",
    Actions: "Actions",
    Home: "Home",
    Landing: "Landing",
    "Sitemap URL": "Sitemap URL",
    "+ Add Sitemap": "+ Add Sitemap",
    "Search by title or URL": "Search by title or URL",
    "Edit Sitemap": "Edit Sitemap",
    "Add New Sitemap": "Add New Sitemap",
    "Update Sitemap": "Update Sitemap",
    "Add Sitemap": "Add Sitemap",
    "Title (EN)": "Title (EN)",
    "Title (AR)": "Title (AR)",
    "Are you sure you want to delete sitemap '{{title}}'?":
      "Are you sure you want to delete sitemap '{{title}}'?",
    "This action cannot be undone.": "This action cannot be undone.",
    Cancel: "Cancel",
    Delete: "Delete",
    Parent: "Parent",
    Level: "Level",
  },
  ar: {
    Title: "العنوان",
    URL: "الرابط",
    Actions: "الإجراءات",
    Home: "الرئيسية",
    Landing: "الصفحة الرئيسية",
    "Sitemap URL": "رابط خريطة الموقع",
    "+ Add Sitemap": "+ إضافة خريطة الموقع",
    "Search by title or URL": "البحث حسب العنوان أو الرابط",
    "Edit Sitemap": "تعديل خريطة الموقع",
    "Add New Sitemap": "إضافة خريطة موقع جديدة",
    "Update Sitemap": "تحديث خريطة الموقع",
    "Add Sitemap": "إضافة خريطة الموقع",
    "Title (EN)": "العنوان (EN)",
    "Title (AR)": "العنوان (AR)",
    "Are you sure you want to delete sitemap '{{title}}'?":
      "هل أنت متأكد أنك تريد حذف خريطة الموقع '{{title}}'؟",
    "This action cannot be undone.": "لا يمكن التراجع عن هذا الإجراء.",
    Cancel: "إلغاء",
    Delete: "حذف",
    Parent: "الأصل",
    Level: "المستوى",
  },
};
